import { render, staticRenderFns } from "./pointStyle.md?vue&type=template&id=ba9700e8&"
import script from "./pointStyle.md?vue&type=script&lang=js&"
export * from "./pointStyle.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba9700e8')) {
      api.createRecord('ba9700e8', component.options)
    } else {
      api.reload('ba9700e8', component.options)
    }
    module.hot.accept("./pointStyle.md?vue&type=template&id=ba9700e8&", function () {
      api.rerender('ba9700e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/radar/pointStyle.md"
export default component.exports